import React from 'react';
import { WarningIcon } from './Icons';

const WordCounter = ({ text, minWords }) => {
    const words = text.trim() ? text.trim().split(/\s+/).length : 0;
    const isValid = words >= minWords;

    return (
        <div className={`flex items-center ${isValid ? 'text-green-500' : 'text-red-500'}`}>
            {!isValid && <WarningIcon />}
            <span className="ml-1">
                {words} word{words !== 1 ? 's' : ''} {!isValid && `(minimum ${minWords})`}
            </span>
        </div>
    );
};

export default WordCounter;
